import { writable } from 'svelte/store';
export const redirectPath = writable('');
